import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class QuestionService{
  // API Instance
  configConnection: any = new ConfigConnection();

  getAll(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}question?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  create(question){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}question`, question, config);
  }

  edit(question, idQuestion){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    console.log(question);
    return axios.put(`${_.configConnection.apiInstance}question/${idQuestion}`, question, config);
  }

  editOption(options, idQuestion){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    console.log(question);
    return axios.put(`${_.configConnection.apiInstance}question/${idQuestion}`, question, config);
  }

  getById(idQuestion){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}question/${idQuestion}`, config);
  }

  getSurveys(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}survey`, config);
  }

  getSurveyById(surveyId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}survey/${surveyId}`, config);
  }

  getSection(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}section`, config);
  }

  getSkill(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}skill`, config);
  }

  delete_question(idQuestion){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.delete(`${_.configConnection.apiInstance}question/${idQuestion}`, config);
  }

  getInactive(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}question/inactive?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  active_question(idQuestion, reactivate){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}question/${idQuestion}/reactivate`, config);
  }
}
